<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="dialogVisible"
    title="请选择主体身份"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
  >
    <div v-if="param.certData && param.certData.length > 0">
      <template v-for="(item, index) in param.certData">
        <div :key="index">
          <el-radio v-model="choosedCert" :label="index">{{
            item.idenName
          }}</el-radio>
        </div>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button
        @click="onSelectCret(param.certData[choosedCert])"
        size="small"
        type="danger"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { ApiMethods, configUrl } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import Clipboard from "clipboard";
export default {
  props: {
    param: {
      type: Object,
      default: {}
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      choosedCert: 0
    };
  },
  created() {},
  methods: {
    close() {
      this.$emit("setSSDialogData", {
        sSDialogVisible: false,
        sSDialogData: null
      });
    },
    onSelectCret(data) {
      const _this = this;
      this.$emit("setSSDialogData", {
        sSDialogVisible: false,
        sSDialogData: {
          certData: data,
          certiType: _this.param.certiType ? _this.param.certiType : ""
        }
      });
    }
  }
};
</script>

<style lang="less">
.g-certi-dialog .el-dialog__footer {
  -webkit-box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  padding: 10px 15px;
}
.g-certi-dialog-conent {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 80px 15px 205px;
  display: flex;
  .img-certi {
    box-sizing: border-box;
    min-height: 636px;
    flex: 1;
    padding-right: 40px;
  }
  .img-certi-img,
  .img-certi-a {
    width: 100%;
    height: auto;
  }
  .right-btn-warp {
    flex: 0 0 175px;
    padding-top: 26px;
  }
  .g-certi-btn {
    width: 100%;
    height: 35px;
    display: block;
    margin-bottom: 15px;
    margin-left: 0;
    &:hover {
      background-color: #fff;
      color: rgba(236, 28, 28, 1);
      border-color: rgba(236, 28, 28, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-list/selectSubjectDialog.vue